module.exports = __webpack_public_path__ + "static/media/background-1.04eb7395.jpg";